import ZtSetDriverSpeedAlarmModal from './zt-set-driver-speed-alarm-modal.vue'
export default ZtSetDriverSpeedAlarmModal
